import React from 'react';
import Contact from '../components/Contact';
import './Page.css';

function ContactPage() {
  return (
    <div className="page-container">
      <Contact />
    </div>
  );
}

export default ContactPage;
